module.exports = __webpack_public_path__ + "static/media/scroll.097d85c6.wav";